// src/components/profile/roi/ScenarioGuidance.jsx
import React from 'react';
import { Info } from 'lucide-react';

export default function ScenarioGuidance() {
  return (
    <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6 rounded-r-lg">
      <div className="flex items-start gap-2">
        <Info className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="font-semibold text-blue-900 mb-2">Understanding Scenario Analysis</h4>
          <div className="text-sm text-blue-800 space-y-1">
            <p>• <strong>Conservative (0.7×):</strong> Assumes slower adoption, limited resources, or challenging market conditions</p>
            <p>• <strong>Base Case (1.0×):</strong> Most likely outcome based on industry benchmarks and typical performance</p>
            <p>• <strong>Aggressive (1.3×):</strong> Assumes strong executive support, optimal conditions, and proven demand</p>
          </div>
          <div className="mt-3 text-xs text-blue-700">
            💡 <strong>Note:</strong> Benefits scale with scenarios while investment remains constant at program cost
          </div>
        </div>
      </div>
    </div>
  );
}